module.exports = __webpack_public_path__ + "assets/d58f1730185884b781a7d6c5fd1e1873.png";